module.exports = __webpack_public_path__ + "img/feedback_done.85f37fcd.svg";